import { ref, watch, computed, onMounted } from "@vue/composition-api";
import store from "@/store";
import { formatCurrency } from "@core/utils/filter";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useGiftsList() {
  // Use toast
  const toast = useToast();

  const refGiftListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    // { key: "id", label: "編號", sortable: true },
    { key: "code", label: "購物禮卷代碼", class: 'sticky-column', sortable: true },
    { key: "user_id", label: "發放人", class: 'sticky-column', sortable: true },
    { key: "actions", label: "操作", class: 'sticky-column' },
    { key: "name", label: "接收人" },
    { key: "theme", label: "主題" },
    { key: "message", label: "訊息", sortable: true },
    { key: "amount", label: "金額", sortable: true, formatter: formatCurrency },
    { key: "status", label: "啟用", sortable: true },
    { key: "created_at", label: "創建日期", sortable: true },
  ];
  const perPage = ref(10);
  const totalRow = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);

  const dataMeta = computed(() => {
    const localItemsCount = refGiftListTable.value
      ? refGiftListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalRow.value,
    };
  });

  const refetchData = () => {
    refGiftListTable.value.refresh();
  };

  const giftsList = ref(null);

  // const filter_user_id = ref(null);
  const filter_customer_id = ref(null);

  watch(
    [currentPage, perPage, searchQuery,
      // filter_user_id,
      filter_customer_id,
    ],
    () => {
      refetchData();
    }
  );

  const fetchGifts = (ctx, callback) => {
    store
      .dispatch("gift/fetchGifts", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        // user_id: filter_user_id.value,
        customer_id: filter_customer_id.value,
      })
      .then((response) => {
        const { gift_vouchers, total } = response.data;
        callback(gift_vouchers);
        totalRow.value = total;
        giftsList.value = gift_vouchers
      })
      .catch((err) => {
        console.log(err);
        toast({
          component: ToastificationContent,
          props: {
            title: "獲取貸款清單時出錯",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  // const userOptions = ref([]);
  const customerOptions = ref([]);

  const refetchOption = () => {
    store
      .dispatch("app/fetchOptionList", {
        // users: true,
        customers: true,
      })
      .then((response) => {
        // userOptions.value = response.data.users;
        customerOptions.value = response.data.customers;
      });
  };

  onMounted(() => {
    refetchOption();
  });

  return {
    fetchGifts,
    tableColumns,
    perPage,
    totalRow,
    currentPage,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    dataMeta,
    giftsList,
    refGiftListTable,
    ability,
    refetchData,
    // filter_user_id,
    filter_customer_id,
    // userOptions,
    customerOptions,
  };
}
